import analysis from './analysis'
import card from './card'
import chart from './chart'
import contact from './contact'
import contextMenuEdit from './context-menu-edit'
import create from './create'
import createRelated from './create-related'
import dashboard from './dashboard'
import demoTrendradar from './demo-trendradar'
import handler from './handler'
import help from './help'
import info from './info'
import intro from './intro'
import list from './list'
import radar from './radar'
import selection from './selection'
import sidebar from './sidebar'
import view from './view'

export default {
    analysis,
    card,
    chart,
    contact,
    contextMenuEdit,
    create,
    createRelated,
    dashboard,
    demoTrendradar,
    handler,
    help,
    info,
    intro,
    list,
    radar,
    selection,
    sidebar,
    view
}
